import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpHeaders }
	from '@angular/common/http';

import { Observable, tap } from 'rxjs';
import { ConfigService } from './ConfigService';
declare var MiniProfiler: any;


//https://gist.github.com/Shaddix/d5585f46334efa86ad3e685541869c18
@Injectable()
export class MiniProfilerInterceptor implements HttpInterceptor {
	constructor(private configData: ConfigService) {}

	intercept(req: HttpRequest<any>,next: HttpHandler): Observable<HttpEvent<any>> {

		var handler: Observable<HttpEvent<any>>;
		if (req.url.toLowerCase().indexOf("mini-profiler-resources") >= 0) {
			const authorizedRequest = req.clone({ headers: this.getMyHeaders() });
			handler =  next.handle(authorizedRequest);
		} else {
			handler = next.handle(req);
		}

		return handler
			.pipe(
				tap(
					evt => {
						if (evt instanceof HttpResponse) {
							if (typeof MiniProfiler !== 'undefined' && evt && evt.headers) {
								this.makeMiniProfilerRequests(evt.headers);
							}
						}
					}
				)
			);
	}

	getMyHeaders(): HttpHeaders {

		var headers = new HttpHeaders(); // ... Set content type to JSON
		if (this.configData.isLoggedIn()) {
			headers = headers.set("Authorization", `${this.configData.user.token_type} ${this.configData.user.access_token}`);
		}
		return headers;
	}


	private makeMiniProfilerRequests(headers: HttpHeaders) {
		const miniProfilerHeaders = headers.getAll('x-miniprofiler-ids');

		if (!miniProfilerHeaders) {
			return;
		}

		miniProfilerHeaders.forEach(miniProfilerIdHeaderValue => {
			const ids = JSON.parse(miniProfilerIdHeaderValue) as string[];
			MiniProfiler.fetchResults(ids);
		});
	}
}
